import React, { useEffect, useState } from "react";

// Replace with your deployed Google Apps Script URL
const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbyCchFjPYf5Q7Bfuq9kkwuDNmR-1r4mq1sPXz92VfXtZkIElYPXOd-28GrZ5VikJbzj/exec";

function ViewReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${SCRIPT_URL}?type=reviewsData`) // fetch full reviews
      .then((res) => res.json())
      .then((data) => {
        // Normalize keys to match your React code
        const normalized = data.map((item) => ({
          name: item.Name || "N/A",
          rating: item.Rating || "N/A",
          comment: item.Comment || "N/A",
          image: item.Image || "",
          date: item.Date || "N/A",
        }));
        setReviews(normalized);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching reviews:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Reviews</h2>

      {loading ? (
        <p>Loading...</p>
      ) : reviews.length === 0 ? (
        <p>No reviews found.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f2f2f2" }}>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Rating</th>
                <th style={thStyle}>Comment</th>
                <th style={thStyle}>Image</th>
                <th style={thStyle}>Date</th>
              </tr>
            </thead>
            <tbody>
              {reviews.map((review, index) => (
                <tr key={index} style={{ textAlign: "center" }}>
                  <td style={tdStyle}>{review.name}</td>
                  <td style={tdStyle}>{review.rating}</td>
                  <td style={tdStyle}>{review.comment}</td>
                  <td style={tdStyle}>
                    {review.image ? (
                      <img
                        src={review.image}
                        alt="Review"
                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td style={tdStyle}>{review.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// Table cell styles
const thStyle = {
  padding: "10px",
  border: "1px solid #ddd",
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #ddd",
};

export default ViewReviews;